import storage from './storage';

export const defaultColors = [
  '#F4F6FF',
  '#CBC5E8',
  '#AEA1D6',
  '#917EC6',
  '#745CB5',
  '#5738A4',
  '#3A1593',
  '#320E86',
  '#2A097A',
  '#1F0069',
];

export const isValidColorTheme = (config: any) =>
  Array.isArray(config?.colour_theme) &&
  config.colour_theme.length === 10 &&
  config.colour_theme.every((color: string) => /^#[0-9A-F]{6}$/i.test(color));

export const setPrimaryColor = (config: any) => {
  const primaryColor = isValidColorTheme(config) ? config?.colour_theme?.[6] : defaultColors[6];
  storage.setItem('primaryColor', primaryColor);
};

export const getColorTheme = (config: any) => {
  const colorTheme = isValidColorTheme(config) ? config?.colour_theme : defaultColors;
  setPrimaryColor(config);
  return colorTheme;
};
